import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import ModalContext from "./ModalContext" // Importez le contexte ici
import { ExclamationTriangleFill } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"

export const ModalProvider = ({ children }) => {
  const { t } = useTranslation()

  const [modalOptions, setModalOptions] = useState({
    show: false,
    titleIcon: null,
    title: null,
    titleClass: "",
    body: null,
    bodyClass: "text-center text-white",
    footer: null,
    hideOnClickOutside: false,
    size: "md",
  })

  const handleTypes = (options) => {
    // console.log("handleTypes", options, modalOptions)

    if (options.type !== undefined) {
      let newOptions = {}
      switch (options.type) {
        case "confirm":
          newOptions = {
            titleIcon: <ExclamationTriangleFill />,
            title: t("message.confirmationRequired"),
            titleClass: "text-danger-light",
            body: options.confirmMessage,
            bodyClass: "text-center text-white font-weight-bold",
            footer: (
              <>
                <Button variant="secondary" size="sm" onClick={hideModal}>
                  {t("action.cancel")}
                </Button>

                <Button variant="danger" size="sm" onClick={options.handle}>
                  {t("action.confirm")}
                </Button>
              </>
            ),
          }
          break
        case "confirmDelete":
          console.log("confirmDelete", options.deleteEntity)
          newOptions = {
            titleIcon: <ExclamationTriangleFill />,
            title: t("message.thisElementWillBeDeleted"),
            titleClass: "text-danger-light",
            body: options.modalConfirmDeleteBody !== undefined ? options.modalConfirmDeleteBody : options.deleteEntity["toStr"] + " (#" + options.deleteEntity.id + ")",
            bodyClass: "text-center text-white font-weight-bold",
            footer: (
              <>
                <Button variant="secondary" size="sm" onClick={hideModal}>
                  {t("action.cancel")}
                </Button>

                <Button variant="danger" size="sm" onClick={options.handleDelete}>
                  {t("action.delete")}
                </Button>
              </>
            ),
          }
          break
        default:
          console.log("type not handled: " + options.type)
          newOptions = options
      }

      // console.log(newOptions)
      return newOptions
    } else {
      return options
    }
  }

  const showModal = (options) => {
    const handledOptions = handleTypes(options)
    console.log(handledOptions)

    setModalOptions({
      ...modalOptions,
      ...handledOptions,
      show: true,
    })
  }

  const hideModal = () => {
    setModalOptions({
      ...modalOptions,
      show: false,
    })
  }

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <Modal show={modalOptions.show} onHide={hideModal} data-bs-theme="dark" backdrop={modalOptions.hideOnClickOutside === false ? "static" : "true"} size={modalOptions.size}>
        {modalOptions.title && (
          <Modal.Header closeButton className="text-white">
            <Modal.Title className={modalOptions.titleClass !== "" ? modalOptions.titleClass : ""}>
              {modalOptions.titleIcon !== "" ? <span className="margin-right-5">{modalOptions.titleIcon}</span> : ""}
              {modalOptions.title}
            </Modal.Title>
          </Modal.Header>
        )}
        {modalOptions.body && <Modal.Body className={modalOptions.bodyClass !== "" ? modalOptions.bodyClass : ""}>{modalOptions.body}</Modal.Body>}
        {modalOptions.footer && <Modal.Footer className="display-block text-center">{modalOptions.footer && modalOptions.footer}</Modal.Footer>}
      </Modal>
    </ModalContext.Provider>
  )
}
